import React from "react";

const Brandfolder = props => (
    <div className="adobe-brandfolder">
        <p>{props.brandfolder.name}</p>
    </div>
);

export default Brandfolder;
